import { Component } from '@angular/core';
import { LoginAuthService } from '../../../service/login-auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ["./login.component.scss"],

})
export class LoginComponent {
  email = '';
  password = '';

  constructor(private authService: LoginAuthService,private router: Router) {}

  onSubmit() {
    //debugger
    this.authService.login(this.email, this.password).subscribe({
      next: (res) => {
        //debugger
        console.log('Login success:', res);
       // const user = res;

        const token = res.Token?.Value?.token;
        const user = res.Token?.Value?.user;

      if (token && user) {
        localStorage.setItem('token', token.trim());
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('UserID', user.Id);
        localStorage.setItem('EmpType', user.EmpType);
        console.log('Login successful, data stored in localStorage');
      } else {
        console.error('Unexpected response format:', res);
      }
        // Save token or user info if returned
        //localStorage.setItem('user', JSON.stringify(res));
        //localStorage.setItem('token', user.token.trim());
         //localStorage.setItem('user', JSON.stringify(user.user));
        // localStorage.setItem('userid', user.user.Id);
        // localStorage.setItem('UserID', user.user.Id);
        // localStorage.setItem('empcode', '');
        this.router.navigate(['/dashboard/default']);
      },
      error: (err) => {
        console.error('Login failed:', err);
      }
    });
  }
}




// import { Component } from '@angular/core';
// import { LoginAuthService } from '../../../service/login-auth.service';

// @Component({
//   selector: 'app-login',
//   templateUrl: './login.component.html',
//   styleUrls: ['./login.component.scss']
// })
// export class LoginComponent {
//   loginData = {
//     email: '',
//     password: ''
//   };

//   constructor(private authService: LoginAuthService) {}

//   onSubmit() {
//     this.authService.login(this.loginData).subscribe({
//       next: (response) => {
//         console.log('Login successful:', response);
//         // Save token or redirect
//         localStorage.setItem('token', response.token);
//       },
//       error: (err) => {
//         console.error('Login failed:', err);
//       }
//     });
//   }
// }



// import { Component, OnInit } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { ActivatedRoute, Router } from '@angular/router';
// import { LoginAuthService } from '../../../service/login-auth.service';
// import { ToastrService } from 'ngx-toastr';

// @Component({
//   selector: 'app-login',
//   templateUrl: './login.component.html',
//   styleUrls: ['./login.component.scss']
// })
// export class LoginComponent implements OnInit {

//   error:any;

//   public loginForm : FormGroup;
//   public isRemember : any;
//   public currentUserInfo : any;
//   public requesting : boolean = false;
//   public buttonClick = false;
//   public loginUserData : any;
//   public loading = false;
//   private uid : number = 0;
//  constructor(private activatedRoute : ActivatedRoute,private  _fb : FormBuilder , private router : Router , private userAuthService : LoginAuthService, private toastr : ToastrService ) {
//     this.loginForm = this._fb.group({
//       email: [null, [Validators.required]],
//       password: [null, [Validators.required]],
//     })
//    }

//   ngOnInit(): void {
//     // this.activatedRoute.queryParams.subscribe(params=>{ 
//     //   //debugger
//     //   this.uid =  JSON.parse(localStorage.getItem('user')).id;
//     //   localStorage.setItem('uid' , this.uid.toString());
//     //   if(this.uid>0)
//     //     this.userProfile(this.uid);
//     //   else{
//     //     if(params['userId']){
//     //       this.userProfile(params['userId']);
//     //       }
//     //   }
//     // })
//   }

//   values=['RS15310','RS14865','RS05461','RS00909'];

//   // login(){
    
//   //   let exist = this.values.find(el=>el == this.loginForm.value.email);
//   //   if(exist){
//   //     return this.toastr.error('Permission Denied for market user !!'); 
//   //   }
//   //   this.buttonClick = true;
    
//   //       //var aa=localStorage.getItem('user');
//   //   if(this.loginForm.valid){
//   //     //debugger
//   //     this.requesting = true;
//   //     this.userAuthService.searchUserWithRoles(this.loginForm.value.email).subscribe((res) =>{
//   //       this.requesting = false;
//   //       if(!res || !res[0]) { 
//   //         //debugger
//   //         return this.toastr.error('User not exist. Try again !!');
//   //       }
//   //       //debugger
//   //       let user = res[0];
//   //       this.userProfile(user['id']);
        
//   //     }
//   //     ,err=>{
//   //       this.toastr.error('something went wrong');
//   //       this.requesting = false;
//   //     })
//   //   }
//   // }

//   // loginInsertToken(){
    
//   //   this.userAuthService.loginInsertToken().subscribe( res =>{
//   //     this.loginCheckUser();
//   //   },err=>{
//   //     console.log(err);
//   //   })
//   // }

//   // loginCheckUser(){
    
//   //   this.userAuthService.loginCheckUser().subscribe((res : any) =>{
//   //     this.loading = false;
//   //     if(!res.userID || !res.Token) return window.location.href = 'https://uatintranet.rspl.net.in/';
//   //     // this.loginUserData = {"UserID":137370,"Token":"A6236C3727798594571D25E60DE8308734669CEE4E552C86C4444942956F9AC53FB91DB71013D7DAAFC41EFF1A71411B239F3A441A739CA13C66CA6262CF08F91D76356DF6141BA6D7CD1471C03378E73B25E2BB704BDBA9D81F4E162CEADCBE2B3794D9"};
//   //     this.loginUserData = {
//   //       "UserID": res.userID,
//   //       "Token": res.Token
//   //     };
      
//   //     this.userAuthService.setTokenLocalStorage(res.Token);
//   //     this.getUserRoleById(res.userID);
//   //     this.userProfile(res.userID);
//   //     this.router.navigateByUrl('/dashboard');
//   //     // this.toastr.success('Login Successfully');

//   //   },err =>{
//   //     this.loading = false;
//   //     console.log(err);
//   //     this.error=err;
//   //   })
//   // }

//   // getUserRoleById(id){
//   //   //debugger
//   //   this.loading = true;
//   //   this.userAuthService.getUserRoleById(id).subscribe((res : any) =>{
//   //     if(!res) {
//   //       this.loading=false; return this.toastr.error('User role not exist, Login Again !!');
//   //     }
//   //     if(res){
//   //       //debugger
//   //       //localStorage.setItem('uid' , res.id);
//   //       //var permission = JSON.parse(localStorage.getItem('userPermission'))
//   //       localStorage.setItem('uid' , id);
//   //       localStorage.setItem('RoleName' , res.roleName);
//   //       let modulePermissionObj={};
//   //       res.rolePermissions.map(element => { modulePermissionObj[element.moduleId]=element; });
//   //       res.rolePermissions = modulePermissionObj;
//   //       localStorage.setItem('userPermission' , JSON.stringify(res));
//   //       this.router.navigateByUrl('/dashboard');
//   //       this.toastr.success('Login Successfully');
//   //       // this.loading = false;
//   //     }
//   //   },err=>{
//   //     this.loading = false;
//   //     if(err.error){
//   //       this.toastr.error(err.error.error);
//   //     }
//   //   })
//   // }

//   // userProfile(id){
    
//   //   this.loading=true;
//   //   this.userAuthService.getUserProfileId(id).subscribe(res =>{
//   //     this.userAuthService.setUserProfile(res);
//   //     this.getUserRoleById(id);
//   //     // Temp token set for user guard
//   //     this.userAuthService.setTokenLocalStorage("A6236C3727798CEE4E552C86C444494295==");
//   //   },err=>{
//   //     this.loading = false;
//   //     if(err.error){
//   //       this.toastr.error(err.error.error);
//   //     }
//   //   })
//   // }

// }


